import React from 'react';
import { Box, Radio, Stack } from '@mantine/core';
import {  ActiveFilter, FilterRendererProps } from '../../types';

const BooleanFilterForModal: React.FC<FilterRendererProps> = ({
  filterConfig,
  filterName,
  selectedCategory,
  localActiveFilters,
  setLocalActiveFilters,
  onCountUpdate,
}) => {
  // Get the correct filterObject from filterConfig
  const filterObject = filterConfig.filterObject || 'evidence';

  // Get current value for this filter
  const existingFilter = localActiveFilters.find(
    filter => filter.name === filterName && filter.filterObject === filterObject
  );
  const currentValue = existingFilter?.selected;

  const handleValueChange = (value: string) => {
    // If "both" is selected, remove the filter
    if (value === 'both') {
      setLocalActiveFilters(prev => 
        prev.filter(filter => !(filter.name === filterName && filter.filterObject === filterObject))
      );
      onCountUpdate?.(0);
      return;
    }

    const newValue = value === 'true';

    const updatedFilter: ActiveFilter = {
      ...filterConfig,
      name: filterName,
      filterObject: filterObject as 'evidence' | 'idea',
      selected: newValue,
      operator: newValue,
      query: null,
      options: undefined, // Override the options from FilterConfig
    };

    setLocalActiveFilters(prev => {
      const existingIndex = prev.findIndex(
        filter => filter.name === filterName && filter.filterObject === filterObject
      );

      let updatedFilters;
      if (existingIndex >= 0) {
        // Update existing filter
        updatedFilters = [...prev];
        updatedFilters[existingIndex] = updatedFilter;
      } else {
        // Add new filter
        updatedFilters = [...prev, updatedFilter];
      }

      return updatedFilters;
    });

    // Update count
    onCountUpdate?.(newValue ? 1 : 0);
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
      <Radio.Group
        value={currentValue === true ? 'true' : currentValue === false ? 'false' : 'both'}
        onChange={handleValueChange}
      >
        <Stack spacing="xs">
          <Radio value="true" label="Yes" color='indigo' />
          <Radio value="false" label="No" color='indigo' />
          <Radio value="both" label="Either" color='indigo' />
        </Stack>
      </Radio.Group>
    </Box>
  );
};

export default BooleanFilterForModal;
